import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ allowRoles }) {
  const { user, bootstrapping, isAuthenticated } = useAuth();
  const location = useLocation();

  if (bootstrapping) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-callisto-app">
        <div className="flex flex-col items-center gap-3" data-testid="auth-bootstrapping">
          <div className="h-10 w-10 rounded-full border-2 border-callisto-gold border-t-transparent animate-spin" />
          <p className="text-sm text-callisto-muted">Loading Callisto…</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (allowRoles && allowRoles.length && !allowRoles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
